import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { Tooltip as NCTooltip } from '@platform/base';
import {
    linkTo,
} from '@platform/api';

class ToolCell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tipStatus: false
        };
    }

    componentWillUnmount() {
        this.cellDom = null;
    }

    handleMouseOver = () => {
        if (this.cellDom) {
            let { tipStatus } = this.state;
            if (this.cellDom.scrollWidth > this.cellDom.clientWidth && tipStatus === false) {
                this.setState({ tipStatus: true });
            }
            if (this.cellDom.scrollWidth <= this.cellDom.clientWidth && tipStatus === true) {
                this.setState({ tipStatus: false });
            }
        }
    };

    render() {
        let { context, multipleRowCell, isLineAll, item={}, moduleId, meta={}, cellValue={} } = this.props;

        return (
            <NCTooltip
                onMouseOver={this.handleMouseOver}
                placement="top"
                overlay={this.state.tipStatus ? context : ''}
                className="tooltip-word-color"
                delay={1}
                inverse
            >
                <span
                    className={classnames(
                        { textLineAll: !multipleRowCell },
                        { noTextLineAll: !isLineAll }
                    )}
                    ref={dom => {
                        this.cellDom = ReactDOM.findDOMNode(dom);
                    }}
                >
                    {
                        item.hyperlinkflag && cellValue.value ? 
                        <a
                            href="javascript:;"
                            className={'hyper-link'}
                            onClick={e => {
                                e.stopPropagation();
                                linkTo(meta.pageid, moduleId, item.attrcode, cellValue.value);
                            }}
                        >
                            {context}
                        </a>:
                        context ? context : <span>&nbsp;</span>
                    }
                </span>
            </NCTooltip>
        );
    }
}

export default ToolCell;
